import { render, staticRenderFns } from "./FinalBatchList.vue?vue&type=template&id=3504b78a&scoped=true&"
import script from "./FinalBatchList.vue?vue&type=script&lang=js&"
export * from "./FinalBatchList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3504b78a",
  null
  
)

export default component.exports